// extracted by mini-css-extract-plugin
export default {"signup-page":"styles_signup-page__RLAOo"};